const pathBase = `/system/admin_profile_statistics/`;

export const adminProfileStatistics = {
  get: () => pathBase,
};
